import React from "react";

const BlogSectionn = () => {
  const blogs = [
    {
      img: "/images/keyword/1.jpg",
      category: "Journey",
      title: "Mumbai Outstation Cabs",
      description:
        "Omshree Cab offers reliable Mumbai outstation cab services with comfortable cars and professional drivers. Enjoy safe, affordable, and on-time travel for your trips from Mumbai to nearby cities. Book your ride easily with Omshree Cab. 🚙",
      authorName: "Hellan",
      authorImg: "/img/profiles/avatar-04.jpg",
      date: "October 6, 2022",
      link: "/Mumbai-Outstation-Cab",
    },
    {
      img: "/images/keyword/3.jpg",
      category: "Tour & tip",
      title: "Mumbai to Goa Cabs",
      description:
        "Omshree Cab provides comfortable and reliable Mumbai to Goa cab services with well-maintained vehicles and experienced drivers. Enjoy a safe, smooth, and affordable road trip from Mumbai to Goa with easy booking and on-time pickup. 🚙",
      authorName: "Alphonsa Daniel",
      authorImg: "/images/keyword/3.jpg",
      date: "March 6, 2023",
      link: "/Mumbai-to-Goa-Cabs",
    },
    {
      img: "/images/keyword/7.jpeg",
      category: "Tour",
      title: "Mumbai to Pune Cab",
      description:
        "Known for its irreverent take on car culture, offers a mix of news, reviews...",
      authorName: "Hellan",
      authorImg: "/img/profiles/avatar-13.jpg",
      date: "March 6, 2023",
      link: "/Mumbai-to-Pune-Cab",
    },
  ];

  return (
    <section className="blog-section news-section bggg pt-0">
      <div className="container">
        {/* Heading */}
        <div className="section-heading" data-aos="fade-down">
          <h2 className="text-white">News & Insights</h2>
          <p className="text-white">This blog post provides valuable insights into the benefits</p>
        </div>

        {/* Blog Posts */}
        <div className="row">
          {blogs.map((blog, index) => (
            <div className="col-lg-4 col-md-6 d-lg-flex " key={index}>
              <div className="blog grid-blog ">
                <div className="blog-image">
                  <a href={blog.link}>
                    <img className="img-fluid" src={blog.img} alt="Post Image" />
                  </a>
                </div>
                <div className="blog-content borderr">
                  <p className="blog-category">
                    <a href="javascript:void(0)">
                      <span>{blog.category}</span>
                    </a>
                  </p>
                  <h3 className="blog-title">
                    <a href={blog.link}>{blog.title}</a>
                  </h3>
                  <p className="blog-description">{blog.description}</p>
              
                </div>
              </div>
            </div>
          ))}
        </div>

      
      </div>
    </section>
  );
};

export default BlogSectionn;